import {AbstractControl, ValidatorFn} from "@angular/forms";

export function urlValidator(): ValidatorFn { // create custom validator function
  return (control: AbstractControl): { [key: string]: any } | null => {
    const linkControl = control.get('link');
    const linkLabelControl = control.get('englishLabel');
    const externalUrlControl = control.get('externalUrl');

    if (linkControl?.value === true && (linkLabelControl?.value === null || linkLabelControl?.value === "" || externalUrlControl?.value === null || externalUrlControl?.value === "")) {
      return {'requiredIfLink': true}; // indicate validation failed
    }
    return null; // indicate validation succeeded
  };
}
